var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button-logo",attrs:{"to":"/"}},[_c('Logo',{staticClass:"button-logo__svg"},[_c('title',[_vm._v("Logo")]),_c('descr',[_vm._v("Go to Homepage")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }